import React, { useState } from 'react'
import { Input, Select, Typography, message } from 'antd'
import { useMsal } from '@azure/msal-react'
import Modal from '../../components/common/modal/modal'
import { MOVEMENT_STATUS_OPTIONS } from './inventoryMovementConstants'
import {
  getApiErrorMessage,
  lookupInventoryProducts
} from '../../api/inventoryMovementApiService/inventoryMovementApiUtils'

const { Text } = Typography

const DEFAULT_FROM_STATUS = 'Good'
const DEFAULT_TO_STATUS = 'Hold'

const AddProductModal = ({ open, onAdd, onClose }) => {
  const { instance } = useMsal()
  const [keycodeInput, setKeycodeInput] = useState('')
  const [fromMovementStatus, setFromMovementStatus] = useState(DEFAULT_FROM_STATUS)
  const [toMovementStatus, setToMovementStatus] = useState(DEFAULT_TO_STATUS)
  const [isAdding, setIsAdding] = useState(false)

  const resetState = () => {
    setKeycodeInput('')
    setFromMovementStatus(DEFAULT_FROM_STATUS)
    setToMovementStatus(DEFAULT_TO_STATUS)
  }

  const handleClose = () => {
    resetState()
    onClose()
  }

  const handleOk = async () => {
    const selectedKeycodes = keycodeInput.split(/[\s,]+/)
    if (!keycodeInput.trim()) {
      handleClose()
      return
    }
    if (fromMovementStatus === toMovementStatus) {
      message.error('From and To status must differ')
      return
    }

    const uniqueKeycodes = [...new Set(selectedKeycodes.map(value => value.trim()).filter(Boolean))]
    const validKeycodes = uniqueKeycodes.filter(keycode => /^\d+$/.test(keycode))
    const unknownKeycodes = uniqueKeycodes.filter(keycode => !/^\d+$/.test(keycode))
    let products = []

    if (validKeycodes.length > 0) {
      setIsAdding(true)
      try {
        const result = await lookupInventoryProducts(instance, validKeycodes)
        products = result.products
        unknownKeycodes.push(...result.notFound)
      } catch (error) {
        message.error(getApiErrorMessage(error, 'Failed to validate keycodes'))
        return
      } finally {
        setIsAdding(false)
      }
    }

    if (unknownKeycodes.length > 0) {
      message.warning(
        unknownKeycodes.length === 1
          ? `Invalid keycode: ${unknownKeycodes[0]} , Please add a valid keycode`
          : `Invalid keycodes: ${unknownKeycodes.join(', ')} , Please add valid keycodes`
      )
    }

    if (products.length > 0) {
      onAdd(products, { fromMovementStatus, toMovementStatus })
    }
    resetState()
  }

  return (
    <Modal
      title="Add Products"
      open={open}
      onOk={handleOk}
      onCancel={handleClose}
      okText="Add"
      confirmLoading={isAdding}
    >
      <Text type="secondary">Enter keycodes separated by commas</Text>
      <Input.TextArea
        rows={3}
        value={keycodeInput}
        placeholder="e.g. 43495573, 43274864, 43329199"
        style={{ width: '100%', marginTop: 8 }}
        onChange={(event) => setKeycodeInput(event.target.value)}
      />

      <Text type="secondary" style={{ display: 'block', marginTop: 16 }}>From Status</Text>
      <Select
        value={fromMovementStatus}
        style={{ width: '100%', marginTop: 8 }}
        options={MOVEMENT_STATUS_OPTIONS.map(option => ({ value: option, label: option }))}
        onChange={setFromMovementStatus}
      />

      <Text type="secondary" style={{ display: 'block', marginTop: 16 }}>To Status</Text>
      <Select
        value={toMovementStatus}
        status={fromMovementStatus === toMovementStatus ? 'error' : undefined}
        style={{ width: '100%', marginTop: 8 }}
        options={MOVEMENT_STATUS_OPTIONS.map(option => ({ value: option, label: option }))}
        onChange={setToMovementStatus}
      />
    </Modal>
  )
}

export default AddProductModal
